import { XMarkIcon } from '@heroicons/react/24/outline';
import { useState } from 'react';
import FileUpload from './FileUpload/FileUpload';
import useImage from '../../hooks/imageHook';
import Button from '../form-control/Button';
import { FaCloudUploadAlt } from 'react-icons/fa';
import { showToast } from '../../utils/miscFunctions';

type UploadLogoProps = {
  partnerId: string;
  onClose: () => void;
  onProceed: () => void;
};
const UploadLogo = ({ partnerId, onClose, onProceed }: UploadLogoProps) => {
  const [submitting, setSubmitting] = useState<boolean>(false);
  const [productIconFile, setProductIconFile] = useState<File | null>();
  const { partnerLogoUpload } = useImage();

  const handleSubmit = () => {
    setSubmitting(true);
    productIconFile &&
      partnerLogoUpload(partnerId, productIconFile)
        .then((response: any) => {
          onProceed();
          showToast.success(response.message, );
        })
        .catch((error: any) => {
          showToast.error(error.description, );
        })
        .finally(() => {
          setSubmitting(false);
        });
  };

  return (
    <div className="w-full">
      <div className="bg-primary-main flex justify-between">
        <div className="p-[1rem] flex justify-between w-full items-center">
          <div className="flex items-center justify-center gap-5">
            <div className="flex items-center justify-center bg-white h-[2.5rem] w-[2.5rem] rounded-full gap-3">
              <FaCloudUploadAlt className="h-5 w-5 " />
            </div>
            <h2 className="font-[gilroy-bold] text-lg">Upload Logo</h2>
          </div>
          <XMarkIcon onClick={onClose} width={'18px'} height={'18px'} className="cursor-pointer" />
        </div>
      </div>

      <div className="p-5 space-y-5">
        <FileUpload
          onFileLoad={(images: any) => {
            if (images && images[0]) {
              setProductIconFile(images[0]);
            }
          }}
          showFileMax={false}
          onFileDeleted={() => {
            setProductIconFile(null);
          }}
          title="Logo"
          label="Logo"
          maxHeight={200}
          maxWidth={200}
          imageContainerHeight={'200px'}
          imageAlt={'Logo'}
        />

        <div className="flex justify-end">
          <Button
            type="submit"
            label="Submit"
            bgColor="primary"
            className="w-fit px-6 text-sm"
            onClick={handleSubmit}
            loading={submitting}
            disabled={submitting}
            curved
          />
        </div>
      </div>
    </div>
  );
};

export default UploadLogo;
